<template>
    <div class="animated fadeIn">
        <div v-if="loading" class="loading-container">
            <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
        </div>
        <form v-else @submit="ValidarForm">
            <div class="row">
                <div class="col-sm-9">
                    <div class="card">
                        <header class="card-header">
                            <strong class="align-self-center">{{
                                $t("sectionModeloMensagem.novoModeloMensagem")
                            }}</strong>
                        </header>
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <small>{{ $t("textObrigatorios") }}</small>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-8">
                                    <div class="form-group">
                                        <strong for>* {{ $t("sectionModeloMensagem.categoria") }}</strong>
                                        <div class="categoria">
                                            <div class="opcao" v-for="opcao in itensCard" :key="opcao.id"
                                                :class="{ 'opcao-selecionada': viewModel.categoria === opcao.id }">

                                                <h4><i :class="opcao.icon"></i> {{ $t(opcao.header) }}</h4>
                                                <label>{{ $t(opcao.text) }}</label>
                                                <input required type="radio" v-model="viewModel.categoria"
                                                    :value="opcao.id" :disabled="$route.params.visualizar">
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-6">
                                    <div class="form-group">
                                        <strong for>* {{ $t("sectionModeloMensagem.nomeModelo") }}</strong>
                                        <input v-model="viewModel.nomeModelo" class="form-control" type="text" :placeholder="$t('sectionModeloMensagem.digiteNomeModelo')
                                            " maxlength="512" required @input="replaceSpaces" :disabled="$route.params.visualizar"/>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-3">
                                    <div class="form-group">
                                        <strong for>* {{ $t("sectionModeloMensagem.idioma") }}</strong>
                                        <select :disabled="$route.params.visualizar" v-model="viewModel.idioma" required class="form-control">
                                            <option value="pt_BR">{{ $t("sectionModeloMensagem.portugues") }}</option>
                                            <option value="en_US">{{ $t("sectionModeloMensagem.ingles") }}</option>
                                            <option value="es">{{ $t("sectionModeloMensagem.espanhol") }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-3">
                                    <div class="form-group">
                                        <strong for>{{ $t("sectionModeloMensagem.cabecalho") }}</strong> <label for
                                            class="badge badge-secondary">{{ $t("sectionModeloMensagem.opcional") }}</label>
                                        <select :disabled="$route.params.visualizar" v-model="viewModel.cabecalho" required class="form-control">
                                            <option value=0>{{ $t("textNenhum") }}</option>
                                            <option value=1>{{ $t("sectionUsuario.usuarioTexto") }}</option>
                                            <option value=2>{{ $t("sectionMidia.midiaTitle") }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-5" v-if="viewModel.cabecalho == 1">
                                    <div class="form-group">
                                        <strong for>{{ $t("sectionModeloMensagem.textoCabecalho") }}</strong>
                                        <input :disabled="$route.params.visualizar" v-model="viewModel.textoCabecalho" class="form-control" type="text"
                                            maxlength="60" />
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-5" v-if="viewModel.cabecalho == 2">
                                    <div class="form-group">
                                        <div class="categoria">
                                            <div class="opcao" v-for="opcao in itensMidia" :key="opcao.id"
                                                :class="{ 'opcao-selecionada': viewModel.tipoMidia === opcao.id }">

                                                <h4><i :class="opcao.icon"></i></h4>
                                                <label>{{ $t(opcao.text) }}</label><br>
                                                <input :disabled="$route.params.visualizar" type="radio" v-model="viewModel.tipoMidia" :value="opcao.id">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="viewModel.tipoMidia === 'IMAGE'" class="col-sm-12 col-md-4 col-lg-4 col-xl-5">
                                    <b-form-file :disabled="$route.params.visualizar" required v-model="viewModel.arquivo" :state="Boolean(viewModel.arquivo)"
                                        :placeholder="$t('sectionModeloMensagem.selectionImage')" accept=".jpg, .png, .jpeg"
                                        :browse-text="$t('textProcurar')"></b-form-file>
                                </div>
                                <div v-if="viewModel.tipoMidia === 'VIDEO'" class="col-sm-12 col-md-4 col-lg-4 col-xl-5">
                                    <b-form-file :disabled="$route.params.visualizar" required v-model="viewModel.arquivo" :state="Boolean(viewModel.arquivo)"
                                        :placeholder="$t('sectionModeloMensagem.selectionVideo')" accept=".mp4"
                                        :browse-text="$t('textProcurar')"></b-form-file>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-12">
                                    <div class="form-group">
                                        <strong for>* {{ $t("sectionModeloMensagem.corpo") }}</strong>
                                        <textarea :disabled="$route.params.visualizar" v-model="viewModel.corpo" class="form-control" type="text"
                                            :placeholder="$t('sectionModeloMensagem.corpoPlaceholder')" maxlength="1024"
                                            required />
                                        <!-- <div>
                                            <label class="btn" type="" v-for="tag in tags" :key="tag.id"
                                                @click="handleTagSelected(tag.id)" style="color: blue;">
                                                {{ tag.id }}
                                            </label>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-6">
                                    <div class="form-group">
                                        <strong for>{{ $t("sectionModeloMensagem.rodape") }}</strong> <label for
                                            class="badge badge-secondary">{{ $t("sectionModeloMensagem.opcional") }}</label>
                                        <input :disabled="$route.params.visualizar" v-model="viewModel.rodape" class="form-control" type="text"
                                            :placeholder="$t('sectionModeloMensagem.textoRodape')" maxlength="60" />
                                    </div>
                                </div>
                            </div>
                            <!-- BOTOES -->
                            <div class="row">
                                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-12">
                                    <div class="form-group">
                                        <strong for>{{ $t("sectionModeloMensagem.botao") }}</strong> <label for
                                            class="badge badge-secondary">{{ $t("sectionModeloMensagem.opcional") }}</label>
                                        <div>
                                            <span>{{ $t("sectionModeloMensagem.descricaoBotao") }}</span>
                                        </div>

                                        <div class="d-flex">
                                            <select :disabled="$route.params.visualizar" v-model="botaoSelecionado" @change="addToSelectedList"
                                                class="form-control col-xl-3">
                                                <option :value="null">{{ $t("sectionModeloMensagem.adicioneBotao") }}
                                                </option>
                                                <option v-for="option in optionsBotao" :value="option.id" :key="option.id"
                                                    :disabled="option.desabilitado">
                                                    {{ option.label }} -
                                                    <small>{{ option.small }}</small>
                                                </option>
                                            </select>
                                        </div>
                                        <small><i class="far fa-lightbulb"></i> {{ $t("sectionModeloMensagem.avisoBotao")
                                        }}</small>
                                        <div v-if="showOptions">
                                            <div v-for="selectedItem in selectedItems" :key="selectedItem.idUnico"
                                                class="card col-xl-11"
                                                style="background-color: rgb(236, 236, 236); margin-left: 5%; margin-top: 1%;">
                                                <div class="d-flex">
                                                    <span>{{ selectedItem.label }}</span>
                                                    <button :disabled="$route.params.visualizar" class="btn btn-danger ml-auto"
                                                        @click="removeFromSelectedList(selectedItem.idUnico)"><i
                                                            class="fas fa-times"></i></button>
                                                </div>
                                                <div class="row" v-if="selectedItem.id === 'QUICK_REPLY'">
                                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-12">
                                                        <div class="form-group" style="margin-left: 5%;">
                                                            <strong>{{ $t("sectionModeloMensagem.textoBotao") }}</strong>
                                                            <input :disabled="$route.params.visualizar" required v-model="selectedItem.textoBotao"
                                                                class="form-control" type="text" maxlength="25" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row" v-if="selectedItem.id === 'PHONE_NUMBER'">
                                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4"
                                                        style="margin-left: 5%;">
                                                        <div class="form-group">
                                                            <strong>{{ $t("sectionModeloMensagem.textoBotao") }}</strong>
                                                            <input :disabled="$route.params.visualizar" required v-model="selectedItem.textoBotao"
                                                                class="form-control" type="text" maxlength="25" />
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-7">
                                                        <div class="form-group">
                                                            <strong>{{ $t("textTelefone") }}</strong>
                                                            <input :disabled="$route.params.visualizar" required v-model="selectedItem.telefone"
                                                                class="form-control" type="text" maxlength="20" placeholder="+5547..."/>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row" v-if="selectedItem.id === 'URL'">
                                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4"
                                                        style="margin-left: 5%;">
                                                        <div class="form-group">
                                                            <strong>{{ $t("sectionModeloMensagem.textoBotao") }}</strong>
                                                            <input :disabled="$route.params.visualizar" required v-model="selectedItem.textoBotao"
                                                                class="form-control" type="text" maxlength="25" />
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 col-md-4 col-lg-4 col-xl-7">
                                                        <div class="form-group">
                                                            <strong>{{ $t("sectionModeloMensagem.urlSite") }}</strong>
                                                            <input :disabled="$route.params.visualizar" required v-model="selectedItem.url" class="form-control"
                                                                type="text" maxlength="2000" />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button :disabled="$route.params.visualizar" class="btn btn-success mr-2" type="submit">
                        {{ $t("btSalvar") }}
                    </button>
                    <button class="btn btn-secondary" type="reset" @click="$router.push('/modelo-mensagem')">
                        {{ $t("btVoltar") }}
                    </button>
                </div>
                <div class="col-sm-3">
                    <div class="card">
                        <header class="card-header">
                            <strong class="align-self-center">
                                {{ $t("sectionModeloMensagem.previa") }}                                 
                                <span v-if="$route.params.visualizar" :title="viewModel.motivoRejeicao" :class="ObterBadgeStatus(viewModel.status)">{{
                                    ObterStatusNome(viewModel.status) 
                                }}</span>
                        </strong>
                                <div>
                                    <span  v-if="viewModel.status === 2">{{ $t("sectionModeloMensagem.motivoRejeicao") }}    <strong>{{ viewModel.motivoRejeicao }}</strong></span>
                                </div>
                        </header>
                        <div class="previa">

                            <div class="chat-bubble">
                                <strong v-if="viewModel.cabecalho == 1">{{ viewModel.textoCabecalho }}</strong>
                                <div v-if="viewModel.cabecalho == 2 && viewModel.tipoMidia == 'IMAGE'"
                                    class="chat-image text-center">
                                    <i v-if="!viewModel.arquivo && !arquivoId" class="fas fa-image"></i>
                                    <img v-else
                                        :src="!arquivoId ? imageUrl : $store.getters.baseURL + 'arquivo/obter/' + arquivoId">
                                </div>
                                <div v-if="viewModel.cabecalho == 2 && viewModel.tipoMidia == 'VIDEO'"
                                    class="chat-image text-center">
                                    <i v-if="!viewModel.arquivo && !arquivoId" class="fas fa-video "></i>
                                    <video v-else controls preload="none">
                                        <source
                                            :src="!arquivoId ? imageUrl : $store.getters.baseURL + 'arquivo/obter/' + arquivoId"
                                            type="video/mp4" />
                                    </video>
                                </div>
                                <p class="chat-text">{{ viewModel.corpo }}</p>
                                <p class="chat-bubble-footer">{{ viewModel.rodape }}</p>
                                <p class="chat-time">{{ horaAtual }}</p>
                                <div v-if="showOptions">
                                    <div v-for="selectedItem in selectedItems" :key="selectedItem.id" class="text-center "
                                        style="color: rgb(0, 132, 255)">
                                        <div class="botoesPrevia" v-if="selectedItem.id === 'QUICK_REPLY'">
                                            <i class="fas fa-reply"></i> {{ selectedItem.textoBotao }}
                                        </div>
                                        <div class="botoesPrevia" v-if="selectedItem.id === 'PHONE_NUMBER'">
                                            <i class="fas fa-phone-alt"></i> {{ selectedItem.textoBotao }}
                                        </div>
                                        <div class="botoesPrevia" v-if="selectedItem.id === 'URL'">
                                            <i class="fas fa-external-link-alt"></i> {{ selectedItem.textoBotao }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
  
<script>
import RotateSquare from "../../components/RotateSquare";
import StatusModeloMensagem from "../../enums/StatusModeloMensagem";

export default {
    name: "NovoModeloMensagem",
    components: {
        RotateSquare,
    },
    data() {
        return {
            loading: false,
            showOptions: false,
            selectedItems: [],
            botaoSelecionado: null,
            arquivoId: null,
            options: [
                { id: 1, label: this.$t("sectionUsuario.usuarioTexto") },
                { id: 2, label: this.$t("sectionMidia.midiaTitle") },
            ],
            itensCard: [
                { id: "MARKETING", icon: "fas fa-bullhorn", header: "sectionModeloMensagem.MARKETING", text: "sectionModeloMensagem.MARKETING_TEXT" },
                { id: "UTILITY", icon: "fas fa-bell", header: "sectionModeloMensagem.UTILITY", text: "sectionModeloMensagem.UTILITY_TEXT" },
                // { id: "AUTHENTICATION", icon: "fas fa-key", header: "sectionModeloMensagem.AUTHENTICATION", text: "sectionModeloMensagem.AUTHENTICATION_TEXT" },
            ],
            itensMidia: [
                { id: "IMAGE", icon: "fas fa-image", text: "sectionParametro.parametroImagem" },
                { id: "VIDEO", icon: "fas fa-video", text: "sectionParametro.parametroVideo" },
            ],
            optionsBotao: [
                { id: "QUICK_REPLY", label: this.$t("sectionModeloMensagem.botaoQuickReply"), small: this.$t("sectionModeloMensagem.personalizado"), desabilitado: false },
                { id: "PHONE_NUMBER", label: this.$t("sectionModeloMensagem.botaoLigar"), small: this.$t("sectionModeloMensagem.maxBotaoLigar"), desabilitado: false },
                { id: "URL", label: this.$t("sectionModeloMensagem.botaoSite"), small: this.$t("sectionModeloMensagem.maxBotaoSite"), desabilitado: false },
            ],
            viewModel: {
                contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
                telefoneId: this.$route.params.id,
                nomeModelo: null,
                categoria: null,
                idioma: null,
                cabecalho: 0,
                textoCabecalho: null,
                tipoMidia: null,
                arquivo: null,
                corpo: "",
                rodape: null
            },

        };
    },
    watch: {
        'viewModel.tipoMidia': function () {
            if (!this.$route.params.visualizar) {
                this.viewModel.arquivo = null
            }
        },
        'viewModel.cabecalho': function () {
            if (!this.$route.params.visualizar) {
                this.textoCabecalho = null,
                    this.viewModel.tipoMidia = null
                this.viewModel.arquivo = null
            }
        }
    },
    computed: {
        tags() {
            return [
                {
                    id: "[URL_CLIENTE]",
                    descricao: this.$t("sectionNovoMensagemPadrao.urlCadastroCliente")
                },
                {
                    id: "[NOME_CLIENTE]",
                    descricao: this.$t("sectionNovoMensagemPadrao.nomeCliente")
                },
                {
                    id: "[ENDERECO_CLIENTE]",
                    descricao: this.$t("sectionNovoMensagemPadrao.enderecoCliente")
                },
                {
                    id: "[NOME_ATENDENTE]",
                    descricao: this.$t("sectionNovoMensagemPadrao.nomeAtendente")
                }
            ];
        },
        horaAtual() {
            const agora = new Date();
            const hora = agora.getHours().toString().padStart(2, '0');
            const minuto = agora.getMinutes().toString().padStart(2, '0');
            return `${hora}:${minuto}`;
        },
        imageUrl() {
            // Verifica se há um arquivo carregado
            if (this.viewModel.arquivo) {
                // Cria uma URL temporária para a imagem carregada
                return URL.createObjectURL(this.viewModel.arquivo);
            }
            return null;
        },
    },
    mounted() {
    },
    created() {
        let id = this.$route.params.visualizar;
        if (id) this.Obter(id);
    },
    methods: {
        ValidarForm(evt) {
            evt.preventDefault();
            if (this.viewModel.categoria != null)
                this.Novo();
            else {
                const categoriaObrigatoria = this.$t(
                    "sectionModeloMensagem.avisoCategoria"
                );
                this.$notify({
                    data: [categoriaObrigatoria],
                    type: "warn",
                    duration: 10000
                });
            }
        },
        Obter(modeloMensagemId) {
            this.loading = true;
            this.$http({
                url: "modelo-mensagem/obter/" +
                    modeloMensagemId + "/" +
                    this.$store.getters.getAutenticacao.contaSelecionadaId,
                method: "GET"
            })
                .then((resposta) => {
                    this.loading = false;
                    this.viewModel = resposta.data;
                    this.arquivoId = resposta.data.arquivoId;

                    if (resposta.data.botoes.length > 0){
                        this.showOptions = true;
                        
                        resposta.data.botoes.forEach(element => {
                            const botaoSelecionadoItem = this.optionsBotao.find((item) => item.id === element.id);
                            element.label = botaoSelecionadoItem.label
                        });
                        this.selectedItems = resposta.data.botoes;
                    }
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: erro.response.data.erros,
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        Novo() {
            this.viewModel.botoes = this.selectedItems;
            console.log("json: ", this.viewModel)
            const formData = new FormData();
            formData.append('ContaId', this.viewModel.contaId);
            formData.append('TelefoneId', this.viewModel.telefoneId);
            formData.append('NomeModelo', this.viewModel.nomeModelo);
            formData.append('Categoria', this.viewModel.categoria);
            formData.append('Idioma', this.viewModel.idioma);
            formData.append('Cabecalho', this.viewModel.cabecalho);
            formData.append('TextoCabecalho', this.viewModel.textoCabecalho);
            formData.append('TipoMidia', this.viewModel.tipoMidia);
            formData.append('Corpo', this.viewModel.corpo);
            formData.append('Rodape', this.viewModel.rodape);
            formData.append('Arquivo', this.viewModel.arquivo);
            formData.append('Botoes', JSON.stringify(this.viewModel.botoes));
            this.loading = true;
            this.$http({
                url: "modelo-mensagem/novo",
                data: formData,
                method: "POST"
            })
                .then(() => {
                    this.loading = false;
                    this.$router.push("/modelo-mensagem");

                    const modeloMensagemCadastradaComSucesso = this.$t(
                        "sectionModeloMensagem.modeloMensagemCadastradoSucesso"
                    );

                    this.$notify({
                        data: [modeloMensagemCadastradaComSucesso],
                        type: "success",
                        duration: 10000
                    });
                })
                .catch((erro) => {
                    this.loading = false;
                    this.$notify({
                        data: [erro.response.data],
                        type: "warn",
                        duration: 10000
                    });
                });
        },
        handleTagSelected(tagId) {
            if(this.$route.params.visualizar)
                return;

            this.viewModel.corpo += " " + tagId;
        },
        addToSelectedList() {
            const botaoSelecionadoItem = this.optionsBotao.find((item) => item.id === this.botaoSelecionado);
            if (botaoSelecionadoItem) {

                const ligarSelectedCount = this.selectedItems.filter(item => item.id === "PHONE_NUMBER").length;
                const urlSelectedCount = this.selectedItems.filter(item => item.id === "URL").length;

                if (ligarSelectedCount === 0 && this.botaoSelecionado === "PHONE_NUMBER")
                    botaoSelecionadoItem.desabilitado = true;

                if (urlSelectedCount === 1 && this.botaoSelecionado === "URL")
                    botaoSelecionadoItem.desabilitado = true;

                const selectedItem = { ...botaoSelecionadoItem };

                selectedItem.idUnico = this.generateGuid();

                this.selectedItems.push(selectedItem);

                this.showOptions = this.selectedItems.length > 0;
                this.botaoSelecionado = null;
            }
        },
        removeFromSelectedList(itemId) {
            const index = this.selectedItems.findIndex((item) => item.idUnico === itemId);

            const botaoExcluir = this.selectedItems.find((item) => item.idUnico === itemId);
            const botaoSelecionadoItem = this.optionsBotao.find((item) => item.id === botaoExcluir.id);

            if (botaoSelecionadoItem.id === "PHONE_NUMBER" || botaoSelecionadoItem.id === "URL")
                botaoSelecionadoItem.desabilitado = false;


            if (index !== -1) {
                this.selectedItems.splice(index, 1);
            }
        },
        generateGuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        replaceSpaces() {
            this.viewModel.nomeModelo = this.viewModel.nomeModelo.replace(/\s/g, '_');
        },
        ObterBadgeStatus(status) {
        switch (status) {
            case StatusModeloMensagem.Aprovado:
            return "badge badge-success";
            case StatusModeloMensagem.Pendente:
            return "badge badge-warning";
            case StatusModeloMensagem.Rejeitado:
            return "badge badge-danger";
            default:
            return "badge badge-secondary";
        }
        },
        ObterStatusNome(status) {
        switch (status) {
            case StatusModeloMensagem.Aprovado:
            return this.$t("sectionModeloMensagem.aprovado");
            case StatusModeloMensagem.Pendente:
            return this.$t("sectionModeloMensagem.pendente");
            case StatusModeloMensagem.Rejeitado:
            return this.$t("sectionModeloMensagem.rejeitado");
            default:
            return this.$t("textNenhum");
        }
        },
    }
}
</script>
<style scoped lang="scss">
.categoria {
    display: flex;
}

.opcao {
    flex: 1;
    border: 1px solid #ccc;
    padding: 5px;
    margin: 5px;
    text-align: center;
    box-sizing: border-box;
    border-radius: 5%;
}

.opcao-selecionada {
    border: 2px solid rgb(50, 143, 248);
}

.previa {
    flex: 1;
    border: 1px solid #ccc;
    padding: 10px;
    text-align: center;
    box-sizing: border-box;
    background: url("/img/fundoWhats.jfif");
}

.botoesPrevia {
    border-top: 1px solid #929292;
    /* Adiciona uma borda superior */
    border-bottom: 1px solid #929292;
    /* Adiciona uma borda inferior */
    padding: 8px 0;
    /* Adiciona um espaçamento interno para melhor aparência */
    text-align: center;
}

.chat-bubble-footer {
    margin: 0;
    font-size: 12px;
    color: #929292;
    word-wrap: break-word;
}

.chat-bubble {
    text-align: left;
    max-width: 80%;
    padding: 10px;
    background-color: #ffffff;
    border-radius: 10px;
    margin: 10px;
    position: relative;
    min-height: 40px;
}

.chat-text {
    margin: 0;
    font-size: 14px;
    color: #000;
    word-wrap: break-word;
}

.chat-image {
    background-color: #d6d6d6;
    color: #000;

    i {
        font-size: 80px;
    }

    img,
    video {
        width: 100%;
        height: 100%;
    }
}

.chat-video {
    width: 100%;
    height: 100%;
}

.chat-bubble::before {
    content: "";
    position: absolute;
    left: -20px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
}

.chat-time {
    margin: 5px 0 0 0;
    font-size: 10px;
    color: #aaa;
    /* Cor cinza mais clara para o horário */
    text-align: right;
}
</style>
  